import React, { useState } from "react";
import "./Login.css"; // Make sure to create a corresponding CSS file
import axios from "axios";
import GetServerAddress from "../../../functions/GetServerAddress";
import { StudentuseAuth } from "../../security/StudentUseAuth";
import { useParams } from "react-router-dom";

const LoginStudent = () => {
  const { urlUsername } = useParams();
  const { urlPassword } = useParams();

  const [Username, setUsername] = useState(
    urlUsername && urlUsername.length > 0 ? urlUsername : ""
  );
  const [Password, setPassword] = useState(
    urlPassword && urlPassword.length > 0 ? urlPassword : ""
  );
  const { loginStudent } = StudentuseAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Here you would usually send a request to your backend to authenticate the user.
    try {
      const response = await axios.post(
        GetServerAddress() + "api/student/login",
        {
          dbName: "Registers_2025",
          collctiontext: "All",
          search: {
            Username: Username,
            Password: Password,
          },
          limit: 100,
          fields: {
            MetaData: 1,
            _id: 1,
          },
        }
      );

      // Handle response here (e.g., navigate to another page, display a message)
      console.log(response.data);
      if (response.data.data.length === 0) {
        alert("Invalid Username or Password");
      } else if (response.data.data.length === 1) {
        await loginStudent(response.data.data, response.data.token);
      } else if (response.data.data.length > 1) {
        alert(
          "Found more than 1 account? Please speak to your IT Department and alert them of this issue"
        );
      }
    } catch (error) {
      // Handle error here (e.g., display an error message)
      console.error("Login error", error);
      alert(
        "Login error, please tell IT department if this issue persists",
        error
      );
    }

    // await login({ Username });
    // alert("Invalid Username or Password");
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>Parent/Student Login</h2>
        <div className="form-group">
          <label htmlFor="Username">Username</label>
          <input
            type="text"
            id="Username"
            value={Username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="Password">Password</label>
          <input
            type="Password"
            id="Password"
            value={Password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default LoginStudent;
